module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    test\n    "), _c('button', {
    on: {
      "click": function($event) {
        _vm.$router.go('/index')
      }
    }
  }, [_vm._v("index")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bd0c14b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/test.vue
// module id = 292
// module chunks = 1